// removed by extract-text-webpack-plugin
module.exports = {"switchContainer":"switchContainer","switch":"switch","dark":"dark"};


//////////////////
// WEBPACK FOOTER
// ./src/view/common/Switch/style.scss
// module id = 1273
// module chunks = 0